export default __webpack_public_path__ + "static/media/Group 1834.f9de328f.png";